export type ResourceState =
  | "LOADED"
  | "UNLOADED"
  | "LOADING"
  | "ERROR"
  | "DIRTY";

export const ResourceStates: {
  loaded: ResourceState;
  unloaded: ResourceState;
  loading: ResourceState;
  error: ResourceState;
  dirty: ResourceState;
} = {
  loaded: "LOADED",
  unloaded: "UNLOADED",
  loading: "LOADING",
  error: "ERROR",
  dirty: "DIRTY",
};
